import { motion } from 'framer-motion';
import React, { useRef } from 'react';
import ReactPlayer from 'react-player';

import PlayIcon from '../PlayIcon/PlayIcon';
import * as styles from './Video.module.css';

import Copy from '@components/Typography/Copy';

const EmbedVideo = ({
	src,
	title,
	showTitle,
	poster,
}: {
	src: string;
	title: string;
	showTitle?: boolean;
	poster?: string | object | null;
}) => {
	const videoPlayer = useRef(null);

	return (
		<motion.div
			className={styles.embed}
			initial="hidden"
			whileInView="visible"
			viewport={{ once: true, amount: 0.6 }}
			transition={{ duration: 0.35 }}
			variants={{
				visible: { opacity: 1 },
				hidden: { opacity: 0 },
			}}>
			<ReactPlayer
				width={'100%'}
				height="auto"
				url={src}
				light={poster}
				controls
				playing
				playIcon={<PlayIcon className={styles.icon} />}
				className={styles.player}
				ref={videoPlayer}
				onEnded={() => videoPlayer?.current?.showPreview()}
			/>

			{showTitle && (
				<Copy font="sm" weight="bold">
					{title}
				</Copy>
			)}
		</motion.div>
	);
};

export default EmbedVideo;
